import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";
import chevronDownCircle from "../../img/experience/chevron-down-circle.svg";
import chevronRightCircle from "../../img/experience/chevron-right-circle.svg";

const ITEMS = [
  { titleKey: "trade.tools.t1", descKey: "trade.tools.t1.desc" },
  { titleKey: "trade.tools.t2", descKey: "trade.tools.t2.desc" },
  { titleKey: "trade.tools.t3", descKey: "trade.tools.t3.desc" },
];

function TradeTools() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-start gap-[40px] xl:gap-[116px]">

        {/* Left: text + CTA */}
        <div className="flex flex-col gap-[40px] xl:gap-0 xl:justify-between xl:h-[371px] xl:w-[504px] xl:shrink-0">
          <div className="flex flex-col gap-[20px] xl:gap-[40px]">
            <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("trade.tools.title")}
            </h2>
            <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
              {t("trade.tools.desc")}
            </p>
          </div>
          <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
        </div>

        {/* Right: accordion */}
        <div className="flex flex-col flex-1">
          {ITEMS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i}>
                <div
                  className="flex flex-col gap-[6px] py-[16px] xl:py-0 xl:mb-[28px] xl:mt-[28px] cursor-pointer"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-['Montserrat'] font-semibold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
                      {t(item.titleKey)}
                    </span>
                    <div className="shrink-0 size-[30px] xl:size-[56px]">
                      {isOpen ? (
                        <img src={chevronDownCircle} alt="" aria-hidden className="w-full h-full rotate-90" />
                      ) : (
                        <img src={chevronRightCircle} alt="" aria-hidden className="w-full h-full" />
                      )}
                    </div>
                  </div>
                  {isOpen && (
                    <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[497px]">
                      {t(item.descKey)}
                    </p>
                  )}
                </div>
                {i < ITEMS.length - 1 && <div className="h-[1px] bg-[#ebebeb]" />}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default TradeTools;
